var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcRain(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.824 4.5C9.95 4.5 8.46 5.968 7.813 6.892c-.695-.062-1.556 0-2.412.196-1.108.256-2.35.772-3.284 1.705-.728.728-1.412 1.914-1.582 3.313-.174 1.44.204 3.061 1.543 4.56a6.522 6.522 0 0 0 1.384 1.173l1.123-1.654-.513-.37a4.527 4.527 0 0 1-.502-.481c-.95-1.064-1.155-2.11-1.05-2.987.112-.919.572-1.701 1.011-2.14L2.824 9.5l.707.707c.58-.579 1.43-.965 2.32-1.17.899-.207 1.693-.196 2.073-.11A1.24 1.24 0 0 0 9.29 8.3C9.486 7.93 10.38 6.5 12.824 6.5c1.324 0 2.178.584 2.726 1.334.577.79.807 1.765.788 2.417a1.21 1.21 0 0 0 1.207 1.249h.28c.53 0 1.332.147 1.966.546.58.366 1.033.94 1.033 1.954 0 1.214-.45 1.967-.972 2.41l-.762.649 1.297 1.523.761-.648c.992-.844 1.676-2.166 1.676-3.934 0-1.786-.88-2.962-1.967-3.646-.845-.533-1.801-.765-2.56-.832a6.28 6.28 0 0 0-1.133-2.868c-.883-1.21-2.311-2.154-4.34-2.154zM8.38 15.474l.475-.88-1.761-.949-.474.88-3.5 6.5-.475.881 1.761.949.474-.88 3.5-6.5zm5.475-.88-.475.88-3.5 6.5-.474.88-1.76-.948.474-.88 3.5-6.5.474-.88 1.76.948zm4.526.88.474-.88-1.761-.949-.474.88-3.5 6.5-.474.881 1.76.949.474-.88 3.5-6.5z",
    fill: "#313030"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcRain);
export default __webpack_public_path__ + "static/media/ic_rain.c1ac597cb587f86f1596e51594167467.svg";
export { ForwardRef as ReactComponent };